import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import api from "../lib/api";
import { RiepBox, RiepSotto, RiepLista, rigaCls, ScadenzaRicetta } from "./RiepBox";

export function DaSistemareBox({ structureId }) {
  const nav = useNavigate();
  const { data: r } = useQuery({ queryKey: ["vm-riepilogo", structureId], refetchInterval: 60000, queryFn: async () => (await api.get("/visite-mediche/riepilogo", { params: { structure_id: structureId } })).data });
  const ric = (r?.ricette || []).filter((x) => x.evento);
  const apri = (id) => nav(`/cartella-clinica?ospite=${id}`);
  return (
    <RiepBox icon={ClipboardList} titolo="Prescrizioni da caricare" count={ric.length} tono="amber" testid="inf-dasistemare-box">
      {!r ? <div className="text-xs text-muted-foreground">Caricamento…</div> : <>
        <RiepSotto>Solo eventi sanitari · {ric.length}</RiepSotto>
        <div className="text-[11px] text-slate-500 mb-0.5">Solo le ricette legate a un evento sanitario. Quelle delle terapie ordinarie sono in Visite mediche.</div>
        <RiepLista items={ric} max={4} testid="inf-ds-ricette" vuoto="Nessuna prescrizione da caricare per gli eventi sanitari."
          render={(x, i) => <button key={i} type="button" onClick={() => apri(x.ospite_id)} className={`${rigaCls} hover:bg-amber-50`} data-testid={`inf-ds-ricetta-${i}`}><span className="font-semibold truncate">{x.nome}</span><ScadenzaRicetta scadenza={x.scadenza} /></button>} />
      </>}
    </RiepBox>
  );
}
